export default __webpack_public_path__ + "4665777145d611134ac55bb80a57a8d2.png";